__turbopack_context__.v({
  "chart": "EL4A1q_chart",
  "label": "EL4A1q_label",
  "output": "EL4A1q_output",
});
